export default __webpack_public_path__ + "static/media/phone-details.4dc47433.svg";